// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// TODO Есть проблемы с синхронизацией элементов первого списка
//      идеи для улучшения:
//          - совместить items и valueOfLists (хранить itemsStr в items)
//          - переопределить TerceraComboBox.onItemsChanged => решить проблему выбора первого списка при загрузке itemsStr при нескольких WL
import { Resources } from '@shared/localizations/Resources';
import { MessageBoxButtonsTextKey, MessageBoxType, showMessageBoxAsync } from '@shared/utils/MessageBoxUtils';
import { TerceraMessageBox } from '../screen/TerceraMessageBox';
import { TerceraRenameScreen } from '../screen/TerceraRenameScreen';
import { TerceraComboBox } from './TerceraComboBox';
import { CustomEvent } from '@shared/utils/CustomEvents';
import { SessionSettings } from '@shared/commons/SessionSettings';
import { validateWatchlistName } from '@shared/utils/Managers/WatchlistManager/WatchlistNameValidator';
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
export class TerceraEditableListComboBox extends TerceraComboBox {
    get valueOfLists() {
        return this.get('valueOfLists');
    }
    constructor() {
        super();
        this.updateProcess = false;
    }
    getType() {
        return 'TerceraEditableListComboBox';
    }
    oncomplete() {
        super.oncomplete();
        this.OnSelectList = new CustomEvent();
        this.OnItemSave = new CustomEvent();
        const storageName = this.get('storageName');
        if (storageName) {
            SessionSettings.sheetsChangedEvents[storageName].Subscribe(this.loadItemLists, this);
        }
        this.loadItemLists(this._guid);
    }
    dispose() {
        const storageName = this.get('storageName');
        if (storageName) {
            SessionSettings.sheetsChangedEvents[storageName].UnSubscribe(this.loadItemLists, this);
        }
        super.dispose();
    }
    createNewClicked() {
        const items = this.get('items');
        const len = items.length;
        const placeholder = this.get('newItemPlaceholder');
        const newListNamePlaceHolder = Resources.getResource(placeholder);
        let listName = newListNamePlaceHolder;
        let newNameFound;
        let ind = 0;
        do {
            // поиск уникального имени для placeholder на rename screen-e
            ind++;
            newNameFound = true;
            for (let i = 0; i < len; i++) {
                if (items[i].text === listName) {
                    listName = newListNamePlaceHolder + ' ' + ind;
                    newNameFound = false;
                }
            }
        } while (!newNameFound);
        const header = this.get('newItemHeader');
        TerceraRenameScreen.show(listName, this.createItemAsync.bind(this), Resources.getResource(header));
    }
    createListMenuItem(name) {
        const additionalActions = [];
        const isAllowSave = this.get('isAllowSave');
        if (isAllowSave) {
            additionalActions.push({
                svgImage: 'save',
                tooltip: this.get('saveTooltip'),
                event: (item) => {
                    this.saveItem(item);
                }
            });
        }
        const isAllowRename = this.get('isAllowRename');
        if (isAllowRename) {
            additionalActions.push({
                svgImage: 'editIcon',
                tooltip: this.get('renameTooltip'),
                event: (item) => {
                    TerceraRenameScreen.show(item.value, (newName) => {
                        void this.renameItemAsync(item, newName);
                    }, Resources.getResource(this.get('renameHeader')));
                    hideContextMenu();
                }
            });
        }
        const isAllowRemove = this.get('isAllowRemove');
        if (isAllowRemove) {
            additionalActions.push({
                svgImage: 'closeCrossBtn',
                tooltip: this.get('removeTooltip'),
                event: (item) => {
                    this.deleteItem(item);
                    hideContextMenu();
                }
            });
        }
        const newItem = {
            type: NewContextMenuItemType.Default,
            text: name,
            value: name,
            additionalActions: additionalActions
        };
        return newItem;
    }
    createItemAsync(listName) {
        return __awaiter(this, void 0, void 0, function* () {
            const header = this.get('newItemHeader');
            const isNameValid = yield this.listNameValidationAsync(listName, Resources.getResource(header), this.createItemAsync.bind(this), null);
            if (!isNameValid) {
                return;
            }
            const items = this.get('items');
            const index = items.length - 2;
            const allLists = this.valueOfLists;
            const newList = { name: listName, itemsStr: '' };
            allLists.splice(index, 0, newList);
            this.ownerID = this._guid;
            const newItem = this.createListMenuItem(listName);
            this.saveItem(newItem);
            items.splice(index, 0, newItem);
            void this.set({ items });
            this.updateListsValue(listName, true, true, true);
            this.ownerID = null;
        });
    }
    renameItemAsync(item, newName) {
        return __awaiter(this, void 0, void 0, function* () {
            const isNameValid = yield this.listNameValidationAsync(newName, Resources.getResource(this.get('renameHeader')), this.renameItemAsync.bind(this, item), item);
            if (!isNameValid) {
                return;
            }
            const renamedList = this.valueOfLists.find((list) => list.name === item.value);
            renamedList.name = newName;
            item.text = item.value = item.tag = newName;
            this.updateListsValue(newName, true, true);
        });
    }
    saveItem(item) {
        this.OnItemSave.Raise(item);
        hideContextMenu();
    }
    deleteItem(item) {
        if (isNullOrUndefined(item)) {
            return;
        }
        const items = this.get('items');
        if (items.length === 3 && !this.get('isAllowRemoveLastItem')) {
            // Need at least one element (+ CreateNew element + separator) except Chart Templates List
            TerceraMessageBox.Show(Resources.getResource('screen.error.title'), Resources.getResource('screen.remove.lastlist'), MessageBoxType.Error, null, null, false, true);
            return;
        }
        TerceraMessageBox.Show(Resources.getResource('screen.remove.title'), Resources.getResource('screen.remove.confirmText.firstPart') +
            "'" +
            item.text +
            "'" +
            Resources.getResource(this.get('removeTxtSecondPart')), MessageBoxType.Question, () => {
            const index = items.indexOf(item);
            const selectedItem = this.get('selectedItem');
            items.splice(index, 1);
            void this.set({ items });
            const allLists = this.valueOfLists;
            allLists.splice(index, 1);
            if (selectedItem === item) {
                this.updateListsValue(null, true);
            }
            else {
                this.updateListsValue(item.value, true, true);
            }
        });
    }
    resetList() {
        const currentList = this.get('selectedItem');
        this.onSelectedItemChanged(currentList, null);
    }
    onSelectedItemChanged(newItem, oldItem) {
        super.onSelectedItemChanged(newItem, oldItem);
        if (this.updateProcess || (this.ownerID && this._guid !== this.ownerID)) {
            return;
        }
        const currentList = this.get('selectedItem');
        if (isNullOrUndefined(currentList) ||
            isNullOrUndefined(newItem) ||
            (!isNullOrUndefined(oldItem) && newItem.value === oldItem.value)) {
            return;
        }
        const selectedlist = this.valueOfLists.find((list) => list.name === newItem.value);
        // some troubles if edit list in other WL in same Workspace
        if (isNullOrUndefined(selectedlist)) {
            return;
        }
        this.updateProcess = true;
        this.OnSelectList.Raise(selectedlist.itemsStr);
        this.updateProcess = false;
    }
    updateListsValue(selectedText, needSort, needRestoreSelectedItem, fromCreate = false) {
        if (this.updateProcess) {
            return;
        }
        let ID = '';
        if (fromCreate) {
            ID = this._guid;
        }
        if (needSort) {
            this.sortMenuItems();
        }
        if (needRestoreSelectedItem) {
            this.restoreCorrectSelectItem(selectedText);
        }
        const storageName = this.get('storageName');
        if (storageName && SessionSettings[storageName]) {
            this.updateProcess = true;
            SessionSettings.setSheetsData(storageName, this.valueOfLists, ID);
            this.updateProcess = false;
        }
    }
    loadItemLists(ownerID) {
        if (this.updateProcess) {
            return;
        }
        this.ownerID = ownerID;
        const strgName = this.get('storageName');
        const storage = SessionSettings[strgName];
        if (isNullOrUndefined(storage)) {
            return;
        }
        const allLists = isValidArray(storage.itemsValue) ? storage.itemsValue : [];
        const newCBItems = [];
        // #89217
        if (allLists.length === 0 && !this.get('isAllowRemoveLastItem')) {
            allLists.push({ name: Resources.getResource('editableComboBox.defaultList'), itemsStr: '' });
        }
        for (let i = 0; i < allLists.length; i++) {
            newCBItems.push(this.createListMenuItem(allLists[i].name));
        }
        newCBItems.push({ type: NewContextMenuItemType.Separator });
        newCBItems.push({
            type: NewContextMenuItemType.Default,
            text: this.get('createNew'),
            tooltip: this.get('createNewTooltip'),
            svgImage: this.get('createNewIcon'),
            event: () => {
                this.createNewClicked();
            }
        });
        const selItem = this.get('selectedItem');
        const selectedText = selItem ? selItem.text : null;
        void this.set({
            items: newCBItems,
            valueOfLists: allLists
        }).then(function () {
            this.ownerID = null;
        }.bind(this));
        if (selectedText) {
            this.restoreCorrectSelectItem(selectedText);
        }
        this.ownerID = null;
    }
    /**
     * Validates the list name against existing names and shows a rename screen if invalid.
     * @param listName The name of the list to validate.
     * @param renameScreenHeader The header for the rename screen.
     * @param renameScreenCallBack The callback function to call after renaming.
     * @param element The element associated with the list name.
     * @returns True if the list name is valid, false otherwise.
     */
    listNameValidationAsync(listName, renameScreenHeader, renameScreenCallBack, element) {
        return __awaiter(this, void 0, void 0, function* () {
            const items = this.get('items');
            const len = items.length - 2;
            const existingNames = items.slice(0, len).map((item) => item.text.trim());
            const error = validateWatchlistName(listName, existingNames);
            if (isValidString(error)) {
                yield showMessageBoxAsync({
                    type: MessageBoxType.Error,
                    title: Resources.getResource('screen.error.title'),
                    message: error,
                    okText: Resources.getResource(MessageBoxButtonsTextKey.Ok)
                });
                TerceraRenameScreen.show(!isNullOrUndefined(element) ? element.text : listName, renameScreenCallBack, renameScreenHeader);
                return Promise.resolve(false);
            }
            return Promise.resolve(true);
        });
    }
    restoreCorrectSelectItem(selectedText) {
        const itemsAfterSort = this.get('items');
        for (let i = 0; i < itemsAfterSort.length; i++) {
            if (itemsAfterSort[i].text === selectedText) {
                void this.set('selectedItem', itemsAfterSort[i]);
                break;
            }
        }
    }
    sortMenuItems() {
        const itemsAll = this.get('items');
        const items = itemsAll.slice(0, itemsAll.length - 2);
        const defaultItems = itemsAll.slice(itemsAll.length - 2);
        const allLists = this.valueOfLists;
        items.sort(function (a, b) {
            if (a.text > b.text) {
                return 1;
            }
            if (a.text < b.text) {
                return -1;
            }
            return 0;
        });
        allLists.sort(function (a, b) {
            if (a.name > b.name) {
                return 1;
            }
            if (a.name < b.name) {
                return -1;
            }
            return 0;
        });
        void this.set({
            items: items.concat(defaultItems),
            valueOfLists: allLists
        });
    }
}
TerceraComboBox.extendWith(TerceraEditableListComboBox, {
    data: function () {
        return {
            isAllowSave: false,
            isAllowRename: false,
            isAllowRemove: false,
            isAllowRemoveLastItem: false,
            saveTooltip: '',
            renameTooltip: '',
            removeTooltip: '',
            valueOfLists: [],
            storageName: null,
            newItemPlaceholder: 'screen.renameScreen.newList.placeholder',
            renameHeader: 'screen.renameScreen.rename.header',
            newItemHeader: 'screen.renameScreen.newList.header',
            createNew: 'editableComboBox.CreateNew',
            createNewTooltip: 'editableComboBox.CreateNew.tooltip',
            createNewIcon: null,
            removeTxtSecondPart: 'screen.remove.confirmText.secondPart',
            showLastValue: true
        };
    }
});
